import { render, staticRenderFns } from "./DeviceInfoChips.vue?vue&type=template&id=01e67aaa&scoped=true&"
import script from "./DeviceInfoChips.vue?vue&type=script&lang=js&"
export * from "./DeviceInfoChips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01e67aaa",
  null
  
)

export default component.exports